module.exports = __webpack_public_path__ + "media/images/menu/icn-login-d6061ced505c83b74f64d9b2a11e00e5.svg";